export function isRightToLeft(language: string) {
  // arabic & urdu
  return ['ar', 'ur'].includes(language);
}
